import { render, staticRenderFns } from "./suffixIcon-editor.vue?vue&type=template&id=0c355a74&scoped=true&"
import script from "./suffixIcon-editor.vue?vue&type=script&lang=js&"
export * from "./suffixIcon-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c355a74",
  null
  
)

export default component.exports